<div class="detail-section__header">
  <span class="detail-section__title">{{ heading() }}</span>
  <ng-content select="[sectionAction]" />
</div>
<ng-content />
